import {
  forkIcon,
  viewIcon,
  likedIcon,
  saveIcon,
  worksIcon,
} from 'assets';

export interface Info {
  key: string,
  title: string,
  icon: string,
  numKey: string,
  num: number
}

export const list = [
  {
    key: 'works',
    title: '作品',
    icon: worksIcon,
    numKey: 'worksNum',
    num: 0
  },
  {
    key: 'glance',
    title: '被浏览',
    icon: viewIcon,
    numKey: 'viewNum',
    num: 0
  },
  {
    key: 'liked',
    title: '被点赞',
    icon: likedIcon,
    numKey: 'praiseNum',
    num: 0
  },
  {
    key: 'save',
    title: '被收藏',
    icon: saveIcon,
    numKey: 'enshrinesNum',
    num: 0
  },
  {
    key: 'adapt',
    title: '被改编',
    icon: forkIcon,
    numKey: 'forkNum',
    num: 0
  }
]